import { getEnv } from "../env";

const basePath = "/service-cv/v1";

async function getBaseUrl() {
  const env = await getEnv();
  // Fallback vers les variables build-time CRA si dispo
  return (
    env.REACT_APP_API_GATEWAY_URL || window.process?.env?.REACT_APP_API_GATEWAY_URL || "http://10.10.10.100:8097"
  );
}

export const cvService = {
  getAll: async () => {
    const baseURL = await getBaseUrl();
    const res = await fetch(`${baseURL}${basePath}/get/all`, {
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
      throw new Error(`Erreur API CV: ${res.status}`);
    }
    return res.json();
  },
};